import React, {FC} from "react";
import cn from "classnames";

import {Align, Height, Rotate, TextType, Width} from "@baseTypes/baseType";

import st from "./flexLine.module.scss";

interface FlexLine extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  align?: Align;
  textType?: TextType;
  width?: Width;
  height?: Height;
  isLink?: boolean;
  rotate?: Rotate;
  isUnselectable?: boolean;
}

const FlexLine: FC<FlexLine> = (props) => {
  const {
    align = Align.Start,
    textType = TextType.Text,
    width = Width.Full,
    height = Height.Auto,
    rotate = Rotate.Row,
    className,
    style,
    children,
    isLink = false,
    isUnselectable = true,
    ...rest
  } = props;
  
  return (
    <div
      className={cn(
        st.line,
        st[`align__${align}`],
        st[`textType__${textType}`],
        st[`width__${width}`],
        st[`height__${height}`],
        st[`rotate__${rotate}`],
        isLink && st.link,
        isUnselectable && st.unselectable,
        className
      )}
      style={style}
      {...rest}
    >
      {children}
    </div>
  );
};
export default FlexLine;
